const MurmurHash3 = require('imurmurhash');

const hash = (text, prefix = 'f') => {
    const cache = {};

    if (!cache[text]) {
        cache[text] = prefix + MurmurHash3(text).result().toString();
    }

    return cache[text];
};

export default hash;